import { Row, Col } from "../../components/Layout";
import React, { useState } from "react";
import dayjs from "dayjs";
import { SearchAutoComplete } from "../../load-build/formControl/SearchAutoComplete";

export const VesselFormElements = (props) => {
  const { 
    portOfExitList, 
    portOfEntryList, 
    vesselList, 
    portError,
    blNumberError,
    containerNumberError,
    sailDateError, 
    etaError,
    initialImoNumber,
    initialBlNumber,
    initialContainerNumber,
    initialPortOfEntryId,
    initialPortOfExitId,
    initialSailDate,
    initialEta
  } = props;

  const initialVessel = vesselList.find(v => v.imo === initialImoNumber) || null;
  const [portOfExit, setPortOfExit] = useState(initialPortOfExitId || '');
  const [portOfEntry, setPortOfEntry] = useState(initialPortOfEntryId || '');
  const [vessel, setVessel] = useState(initialVessel || '');
  const [blNumber, setBlNumber] = useState(initialBlNumber || '');
  const [containerNumber, setContainerNumber] = useState(initialContainerNumber || '');
  const [sailDate, setSailDate] = useState(initialSailDate);
  const [eta, setEta] = useState(initialEta ? initialEta.split(':')[1] : '');

  const maxSailDate = dayjs().add(60, 'day').format('YYYY-MM-DD');
  const minSailDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD');
  const maxEtaDate = dayjs().add(180, 'day').format('YYYY-MM-DD');
  const minEtaDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD');

  const handleChange = (event, newValue) => {
    if (newValue) {
        setVessel(newValue);
    } else {
        setVessel('');
    }
};

  return (
    <Col className="pl-[5%] text-base">
      <Row className="items-center mb-0">
        <label className="text-xs pr-[3%] leading-tight">Port of Exit :</label>
        <select
          className="text-xs ml-[3.2%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px] w-full max-w-[200px]" 
          name="portOfExit"
          value={portOfExit}
          onChange={(event) => setPortOfExit(event.target.value)}
        >
          <option value="" disabled>Select Port</option>
          {portOfExitList.map((port) => (
            <option key={port.locationId} value={port.locationId}>
              {port.descr}
            </option>
          ))}
        </select>
      </Row>
      <br />
      <Row className="items-center mb-0">
        <label className="text-xs pr-[0.5%] leading-tight">Port of Entry :</label>
        <select
          className="text-xs ml-[3.2%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px] w-full max-w-[200px]" 
          name="portOfEntry"
          value={portOfEntry}
          onChange={(event) => setPortOfEntry(event.target.value)}
        >
          <option value="" disabled>Select Port</option>
          {portOfEntryList.map((port) => (
            <option key={port.locationId} value={port.locationId}>
              {port.descr}
            </option>
          ))}
        </select>
        {portError && (
          <p className="text-xs text-red-500 ml-[20%] mb-[-5%]">
            Port of Entry and Exit cannot be same
          </p>
        )}
      </Row>

      <br />
      <Row className="items-center mb-0">
        <label className="text-xs pr-[1.5%]">Vessel :</label>
        <SearchAutoComplete
          name="vessel"
          TextFieldProps={{
            variant: 'outlined',
            placeholder: 'Search..'
          }}
          options={vesselList.map(vessel => ({
            value: vessel.imo,
            label: `${vessel.name_org} (${vessel.imo})`
          }))}
          onChange={handleChange}
          value={vessel}
          className="text-xs ml-[3.2%] pr-[5.5%] p-[3px]"
        />
      </Row>

      <br />
      <Row>
        <label className="text-xs pr-[2%] mb-0">B/L Number :</label>
        <input
          className="text-xs ml-[7%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px] w-full max-w-[185px]"
          name="blNumber"
          value={blNumber}
          onChange={(event) => setBlNumber(event.target.value)}
          type="text"
          maxLength="16"
          minLength="8"
        ></input>
        {blNumberError && (
          <p className="text-xs text-red-500 ml-[20%] mb-[-5%]">
            BL Number is invalid
          </p>
        )}
      </Row>

      <br />
      <Row>
        <label className="text-xs pr-[2%] mb-0">Container Number :</label>
        <input
          className="text-xs ml-[1.5%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px] w-full max-w-[163px]"
          name="containerNumber"
          value={containerNumber}
          onChange={(event) => setContainerNumber(event.target.value)}
          type="text"
          maxLength="11"
        ></input>
        {containerNumberError && (
          <p className="text-xs text-red-500 ml-[20%] mb-[-5%]">
            Container Number is invalid
          </p>
        )}
      </Row>

      <br />
      <Row>
        <label className="text-xs pr-2 w-1/4">Sail Date :</label>
        <input
          type="date"
          className="text-xs border-[1px] border-gray-500 rounded-sm p-[3px] w-52"
          name="sailDate"
          value={sailDate}
          onChange={(event) => setSailDate(event.target.value)}
          min={minSailDate}
          max={maxSailDate}
          placeholder="Select Date"
        />
        {sailDateError && (
          <p className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            Date is invalid
          </p>
        )}
      </Row>

      <br />
      <Row>
        <label className="text-xs pr-2 w-1/4">ETA :</label>
        <input
          type="date"
          className="text-xs border-[1px] border-gray-500 rounded-sm p-[3px] w-52"
          name="eta"
          value={eta}
          onChange={(event) => setEta(event.target.value)}
          min={minEtaDate}
          max={maxEtaDate}
          placeholder="Select Date"
        />
        {etaError && (
          <p className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            Date is invalid
          </p>
        )}
      </Row>
    </Col>
  );
};